import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaUpload, FaUser, FaSync } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../InputForm/Form";

function ExcelData({ setpartnum, formData, setFormData, disabled, licenseValid, tenant, company }) {
  const [file, setFile] = useState(null);
  //const [formData, setFormData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [uploadMessage, setUploadMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default items per page
  const [apiData, setApiData] = useState([]);
  const [tenantInputVisible, setTenantInputVisible] = useState(false);
  const [tenantId, setTenantId] = useState("");
  useEffect(() => {
    // Load data from localStorage on component mount
    if (formData?.length > 0) {
      /* const storedData = JSON.parse(localStorage.getItem('formData'));
    if (storedData && storedData.length > 0) {
      setFormData(storedData);
      setShowForm(true);
    }}*/
      setShowForm(true);
    }
  }, []);

  /* useEffect(() => {
    // Save data to localStorage whenever formData changes
    if (formData.length > 0) {
      localStorage.setItem('formData', JSON.stringify(formData));
    }
  }, []);*/

  const toggleForm = () => {
    setShowForm(!showForm);
  };

  const onFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setUploadMessage("Uploading data, please wait...");
      setSuccessMessage(""); // Clear success message when a new file is selected
      await onUpload(selectedFile);
    }
  };

  const onUpload = async (file) => {
    if (!file) {
      toast.error("No File is uploaded");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("file", file);
    formDataToSend.append("company", company); // ⬅️ Add company here

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/testUploading/uploadInEpicor`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const dataArray = response.data;
      setFormData(dataArray);
      localStorage.setItem("formData", JSON.stringify(dataArray));
      setpartnum(
        dataArray.map((x) => ({
          partNum: x.partLot_PartNum,
          elementId: x.partLot_LotNum,
          numberOfPieces: x.partLot_Count_c,
          length: x.partLot_Length_c,
          width: x.partLot_Width_c,
          height: x.partLot_Depth_c,
          density: x.partLot_Density_c ?? x.partLot_Denisty_c,
          fc: x.partLot_FC_c ?? x["partLot_F'C_c"],
          type: x.partLot_Type_c,
        })),
      );
      setApiData(dataArray);
      setFile(null);
      setShowForm(true);
      setUploadMessage("");
      setSuccessMessage("Data uploaded successfully!");
    } catch (error) {
      toast.error("Error uploading file");
      setUploadMessage("");
    }
  };

  // Pagination methods
  const totalPages = Math.ceil(formData?.length / itemsPerPage);

  const handleClickPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Get current items for the page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = formData?.slice(indexOfFirstItem, indexOfLastItem);

  // Pagination button functions
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to the first page on items per page change
  };
  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const goToNextPage = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const renderPageNumbers = () => {
    const totalPages = Math.ceil(apiData.length / itemsPerPage);
    const maxPageNumbersToShow = 3;
    let pageNumbers = [];

    let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage + 1 < maxPageNumbersToShow) {
      startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => goToPage(i)}
          className={`pagination-btn ${i === currentPage ? "active" : ""}`}
        >
          {i}
        </button>,
      );
    }

    return (
      <div className="pagination-controls">
        <button onClick={goToPreviousPage} disabled={currentPage === 1} className="pre-nex">
          Previous
        </button>
        {pageNumbers}
        <button onClick={goToNextPage} disabled={currentPage === totalPages} className="pre-nex">
          Next
        </button>
      </div>
    );
  };

  return (
    <div className="overflow-auto">
      <ToastContainer />
      <div className="title-bg rounded d-flex justify-content-between">
        <div>
          <h3>Smart Planner AAC</h3>
        </div>

        <div className="d-flex align-items-center">
          <label
            htmlFor={disabled ? undefined : "file-upload"} // remove htmlFor if disabled
            className="upload-icon-label"
            style={{
              cursor: disabled ? "not-allowed" : "pointer",
              color: disabled ? "gray" : "black",
            }}
          >
            <FaUpload size={17} />
          </label>

          <input
            id="file-upload"
            type="file"
            onChange={onFileChange}
            style={{ display: "none" }}
            disabled={disabled}
          />

          <div className="d-flex align-items-center ms-2">
            <label
              onClick={() => {
                if (licenseValid) {
                  // only allow click if license is NOT valid
                  // const tenant = tenant; // fallback if empty
                  window.location.reload();
                }
              }}
              style={{
                cursor: licenseValid ? "pointer" : "not-allowed",
                color: licenseValid ? "black" : "gray",
              }}
              title={
                licenseValid ? "Click to refresh with tenant" : "License is valid, no action needed"
              }
            >
              <FaSync size={17} />
            </label>
          </div>
          <div className="d-flex align-items-center ms-2">
            <label
              onClick={() => !licenseValid && setTenantInputVisible(true)}
              style={{
                cursor: licenseValid ? "not-allowed" : "pointer",
                color: licenseValid ? "gray" : "black",
              }}
              title={
                licenseValid ? "License is valid, no action needed" : "Click to enter tenant ID"
              }
            >
              <FaUser size={17} />
            </label>
          </div>
        </div>
      </div>

      <div className="title-bg-ItemsDetails d-flex justify-content-between align-items-center mt-2 m-1">
        <div className="mt-3">
          <div>
            <button
              className="toggle-btn my-3 mx-5"
              onClick={toggleForm}
              style={{
                cursor: licenseValid ? "pointer" : "not-allowed",
                color: licenseValid ? "black" : "gray",
              }}
            >
              <i
                className="bi bi-arrow-down-short"
                style={{
                  fontSize: "2rem",
                  fontWeight: "bolder",
                  color: licenseValid ? "black" : "gray",
                }}
              ></i>
              Items Details
            </button>
          </div>
        </div>
      </div>
      {uploadMessage && (
        <div
          className="upload-message bg-success"
          style={{ color: "white", padding: "10px", borderRadius: "5px", marginTop: "10px" }}
        >
          <p>{uploadMessage}</p>
        </div>
      )}

      {successMessage && (
        <div
          className="success-message bg-success"
          style={{ color: "white", padding: "10px", borderRadius: "5px", marginTop: "10px" }}
        >
          <p>{successMessage}</p>
        </div>
      )}
      {showForm && formData.length > 0 && (
        <div>
          <table className="table table-hover table-bordered table-excel-sheet my-2">
            <thead>
              <tr>
                <th className="blue-table-header">Item Type</th>
                <th className="blue-table-header">Thickness</th>
                <th className="blue-table-header">Width</th>
                <th className="blue-table-header">Length</th>
                <th className="blue-table-header">Quantity</th>
                <th className="blue-table-header">Density</th>
                <th className="blue-table-header">F'C</th>
                <th className="blue-table-header">Type</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((data, index) => (
                <tr
                  key={index}
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate(`/form/Reinforcement/${data.partLot_LotNum}/${company}`)}
                >
                  <td>{data.partLot_BuildingType_c}</td>
                  <td>{data.partLot_Depth_c}</td>
                  <td>{data.partLot_Width_c}</td>
                  <td>{data.partLot_Length_c}</td>
                  <td>{data.partLot_Count_c}</td>
                  <td>{data.partLot_Density_c ?? data.partLot_Denisty_c}</td>
                  <td>{data.partLot_FC_c ?? data["partLot_F'C_c"]}</td>
                  <td>{data.partLot_Type_c}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* <div className="d-flex justify-content-between align-items-center my-2">
            
          <div>
              <label>Items per page:</label>
              <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
              </select>
            </div>
            <div>
              <button onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
              <button onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
            </div>


           
          </div> */}
          <div className="pagination-batching">
            <div className="items-per-page">
              <label htmlFor="itemsPerPage">Show </label>
              <select
                className="mx-1"
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              <label htmlFor="itemsPerPage"> entries</label>
            </div>
            {renderPageNumbers()}
          </div>
        </div>
      )}
      {tenantInputVisible && !licenseValid && (
        <div
          className="tenant-modal-overlay"
          onClick={() => setTenantInputVisible(false)} // close if clicking outside
        >
          <div
            className="tenant-modal-content"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <h5>Enter Tenant ID</h5>
            <div className="d-flex align-items-center mt-2">
              <input
                type="text"
                id="tenantInput"
                value={tenantId}
                onChange={(e) => setTenantId(e.target.value)}
                className="form-control me-2"
                placeholder="Tenant ID"
              />
              <button
                className="btn btn-primary"
                onClick={() => {
                  //  const tenant = tenant;
                  navigate(`/form/${tenantId}`);
                  setTenantInputVisible(false); // close modal after submit
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
}

export default ExcelData;
